import React, { Component } from 'react';
import { connect } from 'react-redux';

import * as contentActions from '../content/content.actions';
import { getInnerCircleContent } from '../content/content.selectors';

import { ContentSection, PageHeader } from './components';
import ContentList from '../content/components/ContentList';
import {Localize} from '../../locale/localization';

class InnerCircleArchivePage extends Component {
  componentWillMount = () => {
    const { getContents } = this.props;
    getContents();
  }

  render() {
    const {
      content,
    } = this.props;
    return (
      <div>
        <PageHeader title="Sisäpiiritieto" />
        <ContentSection>
          <ContentList
            title={Localize("news.all")}
            items={content}
            type="inner-circle"
            isArchive
            widths={['20%', '40%', '40%']}
          />
        </ContentSection>
      </div>
    );
  }
};

const mapStateToProps = (state) => {
  const content = getInnerCircleContent(state);
  return {
    content,
  };
};

const ConnectedInnerCircleArchivePage = connect(
  mapStateToProps,
  Object.assign({}, contentActions),
)(InnerCircleArchivePage);

export default ConnectedInnerCircleArchivePage;


// WEBPACK FOOTER //
// ./src/modules/pages/InnerCircleArchivePage.js